import PharmacyTagsPage from './PharmacyTagsPage';

export default PharmacyTagsPage;
